module.exports = __webpack_public_path__ + "static/media/cas_email.1d298db9.jpg";